export default {
  title: 'common',

  fontSize: {
    xSmall: {
      fs08: '4px',
      fs10: '6px',
      fs12: '8px',
      fs14: '10px',
      fs16: '12px',
      fs18: '14px',
      fs20: '16px',
      fs24: '20px',
      fs30: '26px',
      fs32: '28px',
      fs50: '50px',
      title: {
        fs1: '32px',
        fs2: '20px',
        fs3: '18px',
        fs4: '14px',
        fs5: '12px',
        fs6: '10px',
      },
    },
    small: {
      fs08: '6px',
      fs10: '8px',
      fs12: '10px',
      fs14: '12px',
      fs16: '14px',
      fs18: '16px',
      fs20: '18px',
      fs24: '22px',
      fs30: '28px',
      fs32: '30px',
      fs50: '50px',
      title: {
        fs1: '36px',
        fs2: '22px',
        fs3: '20px',
        fs4: '16px',
        fs5: '13px',
        fs6: '11px',
      },
    },
    normal: {
      fs08: '8px',
      fs10: '10px',
      fs12: '12px',
      fs14: '14px',
      fs16: '16px',
      fs18: '18px',
      fs20: '20px',
      fs24: '24px',
      fs30: '30px',
      fs32: '32px',
      fs50: '50px',
      title: {
        fs1: '40px',
        fs2: '25px',
        fs3: '23px',
        fs4: '18px',
        fs5: '15px',
        fs6: '12px',
      },
    },
    large: {
      fs08: '10px',
      fs10: '12px',
      fs12: '14px',
      fs14: '16px',
      fs16: '18px',
      fs18: '20px',
      fs20: '22px',
      fs24: '26px',
      fs30: '32px',
      fs32: '34px',
      fs50: '50px',
      title: {
        fs1: '44px',
        fs2: '28px',
        fs3: '25px',
        fs4: '20px',
        fs5: '17px',
        fs6: '14px',
      },
    },
    xLarge: {
      fs08: '12px',
      fs10: '14px',
      fs12: '16px',
      fs14: '18px',
      fs16: '20px',
      fs18: '22px',
      fs20: '24px',
      fs24: '28px',
      fs30: '34px',
      fs32: '36px',
      fs50: '50px',
      title: {
        fs1: '48px',
        fs2: '30px',
        fs3: '28px',
        fs4: '22px',
        fs5: '18px',
        fs6: '16px',
      },
    },
  },

  size: {
    xsmall: '321px',
    small: '376px',
    medium: '481px',
    large: '769px',
    xlarge: '1025px',
    xxlarge: '1201px',
  },

  zIndex: {
    footer: '10',
    main: '10',
    header: '20',
    menu: '30',
    sideBar: '40',
  },

  color: {
    default: {
      main: '#999999',
    },
    primary: {
      main: '#3276B1',
    },
    success: {
      main: '#739E73',
    },
    info: {
      main: '#57889C',
    },
    warning: {
      main: '#C79121',
    },
    danger: {
      main: '#A90329',
    },
  },

  alert: {
    default: {
      main: '#f3f1f5',
    },
    success: {
      main: '#cde0c4',
    },
    info: {
      main: '#d6dde7',
    },
    warning: {
      main: '#efe1b3',
    },
    danger: {
      main: '#c26565',
    },
  },

  fontColor: {
    default: {
      main: '#696969',
    },
    white: {
      main: '#fff',
    },
    black: {
      main: '#000',
    },
    success: {
      main: '#356635',
    },
    info: {
      main: '#305d8c',
    },
    warning: {
      main: '#826430',
    },
    danger: {
      main: '#953b39',
    },
  },

  institutionalColor: {
    primary: {
      main: '#034694',
      light: '#4097e1',
    },
    secundary: {
      main: '#ffdf3a',
      main2: '#FD98D6',
    },
  },
};
